<template>
  <div>
    <div class="admin">
      <div class="fluid-container">
        <div class="row no-gutters">
          <!-- menu admin -->
          <div class="col-3">
            <menu-admin></menu-admin>
          </div>
          <!-- menu admin -->

          <!-- main -->
          <div class="col-9 main">
            <div class="row">
              <div class="col-12 mb-2">
                <div class="title-admin">
                  <h1 class="display-5 font-weight-black">Productos</h1>
                  <div class="acciones">
                    <v-btn large color="primary" to="/admin/agregar-producto">
                      <v-icon class="mr-3">add</v-icon>Agregar producto
                    </v-btn>
                  </div>
                </div>
              </div>
            </div>

            <!-- filtrar bar -->
            <div class="row mt-4">
              <div class="col-8">
                <v-select
                  :items="categorias"
                  label="Categorías"
                  v-model="categoria"
                  outlined
                  item-text="nombre"
                  item-value="id"
                ></v-select>
              </div>
              <div class="col-2 mt-1">
                <v-btn large color="grey" dark @click="buscarConsulta()">
                  <v-icon class="mr-3">settings_overscan</v-icon>Filtrar
                </v-btn>
              </div>
              <div class="col-2 mt-1">
                <v-btn @click="resetFiltro()" outlined large color="grey" dark
                  >Borrar filtro</v-btn
                >
              </div>
            </div>
            <!-- /filtrar bar -->

            <!-- tabla de ventas -->
            <div class="row mt-0 mb-5">
              <div class="col-12">
                <div>
                  <div
                    class="top d-flex align-items-center justify-content-between mb-3"
                  >
                    <h2 class="font-weight-black">Productos</h2>

                    <div class="right">
                      <v-btn
                        class="mr-2"
                        @click="getProductosBtn()"
                        large
                        outlined
                        color="orange"
                        >Ver todos los productos</v-btn
                      >
                      <v-btn
                        to="/admin/print/productos"
                        large
                        outlined
                        color="primary"
                      >
                        <v-icon class="mr-3">print</v-icon>Ver vista de
                        impresión
                      </v-btn>
                    </div>
                  </div>

                  <!-- loader -->
                  <div
                    v-if="loaderProductos"
                    class="text-center loader-wrap-min"
                  >
                    <div
                      class="spinner-border text-primary"
                      style="width: 75px; height: 75px"
                      role="status"
                    >
                      <span class="sr-only">Loading...</span>
                    </div>
                  </div>
                  <!-- /loader -->

                  <div v-if="!loaderProductos">
                    <!-- datatable -->
                    <v-card v-if="ventas != ''">
                      <v-card-title>
                        <v-text-field
                          v-model="search"
                          append-icon="search"
                          label="Buscar"
                          single-line
                          hide-details
                          @keyup="setBuscadorVuex()"
                        ></v-text-field>
                      </v-card-title>
                      <v-data-table
                        :headers="headers"
                        :items="productos"
                        :search="search"
                      >
                        <template v-slot:item.imagen_destacada="{ item }">
                          <img
                            :src="item.imagen_destacada"
                            alt
                            class="mr-3"
                            v-if="item.imagen_destacada != ''"
                            style="width: 40px; padding: 10px 0"
                          />
                          <img
                            src="https://image.flaticon.com/icons/svg/137/137665.svg"
                            alt
                            class="mr-3"
                            v-else
                            style="width: 40px; padding: 10px 0"
                          />
                        </template>

                        <template v-slot:item.inventario="{ item }">
                          <div v-if="item.inventario == 0">
                            <span class="badge badge-danger">0 en stock</span>
                          </div>
                          <div v-else>
                            <span class="badge badge-success"
                              >{{ item.inventario }} en stock</span
                            >
                          </div>
                        </template>
                        <template v-slot:item.acciones="{ item }">
                          <v-btn
                            class="mx-2"
                            text
                            dark
                            small
                            color="primary"
                            :to="
                              '/admin/producto/' + item.producto_id + '/editar'
                            "
                          >
                            <v-icon dark>visibility</v-icon>
                          </v-btn>
                        </template>
                      </v-data-table>
                    </v-card>
                    <!-- /datatable -->

                    <!-- vacio -->
                    <div v-if="ventas == ''">
                      <div class="vacio">
                        <span>No hemos encontrado ventas</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /tabla de ventas -->
          </div>
          <!-- /main -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const axios = require("axios");
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      productos: [],
      loader: true,
      buscar: "",
      categorias: "",
      categoria: "",
      loaderProductos: true,

      //Table
      search: "",
      headers: [
        {
          text: "#SKU",
          align: "left",
          sortable: false,
          value: "sku",
        },
        { text: "Imagen", value: "imagen_destacada" },
        { text: "Nombre", value: "nombre" },
        { text: "Categoría", value: "categoria" },
        { text: "Precio", value: "precio_pesos" },
        { text: "Inventario", value: "inventario" },
        { text: "Acciones", value: "acciones" },
      ],
    };
  },
  methods: {
    buscarConsulta() {
      if (this.categoria == "" || this.categoria == "selecciona") {
        //No seleccionaron la categoria
        this.$swal({
          type: "error",
          customClass: "arriba",
          title: "Ingresa la categoría a la que pertenece el producto",
          showConfirmButton: true,
        });
      }
      //No ingresó término de búsqueda pero si la categoría
      else if (this.categoria != "" || this.categoria != "selecciona") {
        //Traemos todos los productos de la categoría
        this.loaderProductos = true;
        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getProductosCategoria" +
              "&categoria=" +
              this.categoria
          )
          .then((response) => {
            console.log(response);
            this.productos = response.data;
            this.loaderProductos = false;

            //Guardamos desde en vuex
            this.$store.commit({
              type: "setProductoBuscador",
              categoria: this.categoria,
              search: this.search,
            });
          })
          .catch((error) => console.log(error));
      } else {
        this.loaderProductos = true;
        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=searchProductoInCategoria" +
              "&categoria=" +
              this.categoria +
              "&search=" +
              this.buscar
          )
          .then((response) => {
            console.log(response);
            this.productos = response.data;
            this.loaderProductos = false;
          })
          .catch((error) => console.log(error));
      }
    },
    resetFiltro() {
      this.loader = true;
      this.buscar = "";
      this.categoria = "selecciona";
      this.loaderProductos = true;
      this.getProductos();
    },

    getCategorias() {
      //Obtenemos los productos
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getCategorias"
        )
        .then((response) => {
          this.categorias = response.data;
        })
        .catch((error) => console.log(error));
    },

    getProductos() {
      this.loaderProductos = true;
      //Obtenemos los productos
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getProductos"
        )
        .then((response) => {
          console.log(response);
          this.loaderProductos = false;
          this.productos = response.data;
          this.loaderProductos = false;
        })
        .catch((error) => console.log(error));
    },
    getProductosBtn() {
      this.loaderProductos = true;
      this.categoria = "";
      //Obtenemos los productos
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getProductos"
        )
        .then((response) => {
          console.log(response);
          this.loaderProductos = false;
          this.productos = response.data;
          this.loaderProductos = false;
        })
        .catch((error) => console.log(error));
    },
    print() {
      window.print();
    },
    setBuscadorVuex() {
      //Guardamos desde en vuex
      this.$store.commit({
        type: "setProductoBuscador",
        categoria: this.categoria,
        search: this.search,
      });
    },
    revisarHistorialFiltrado() {
      if (this.buscarProductoCategoria != "") {
        //Traemos todos los productos de la categoría
        this.loaderProductos = true;
        this.search = this.buscarProductoTermino;
        this.categoria = this.buscarProductoCategoria;
        axios
          .get(
            "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getProductosCategoria" +
              "&categoria=" +
              this.buscarProductoCategoria
          )
          .then((response) => {
            console.log(response);
            this.productos = response.data;
            this.loaderProductos = false;

            //Guardamos desde en vuex
            this.$store.commit({
              type: "setProductoBuscador",
              categoria: this.categoria,
              search: this.search,
            });
          })
          .catch((error) => console.log(error));
      } else if (
        this.buscarProductoCategoria != "" &&
        this.buscarProductoTermino != ""
      ) {
        this.getProductos();
        this.search = this.buscarProductoTermino;
      } else {
        this.getProductos();
        this.search = this.buscarProductoTermino;
      }
    },
  },
  computed: {
    ...mapState(["buscarProductoCategoria", "buscarProductoTermino"]),
  },
  mounted() {
    this.revisarHistorialFiltrado();
    this.getCategorias();
  },
};
</script>
